import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  addWeightLog,
  deleteWeightLog,
} from "../services/firebase-weight-service";
import { addGuestWeight } from "../services/guestStorage";

export const useWeightMutations = (uid) => {
  const queryClient = useQueryClient();
  const isGuest = !uid || uid === "guest";

  const addWeightMutation = useMutation({
    mutationFn: (data) => (isGuest ? addGuestWeight(data) : addWeightLog(uid, data)),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["weights", uid] });
    },
  });

  const deleteWeightMutation = useMutation({
    mutationFn: (logId) => (isGuest ? Promise.resolve() : deleteWeightLog(uid, logId)),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["weights", uid] });
    },
  });

  return { addWeightMutation, deleteWeightMutation };
};
